import React, { Fragment } from 'react'
import { Modal,  Button } from 'react-bootstrap'

const NewUserCreatedModal = (props) => {

  const { show, newUser, savingUser, handleClose } = props

  return (
    <Modal show={show}>
      <Modal.Header closeButton onHide={savingUser ? () => null : handleClose}>
        <Modal.Title>
          {savingUser ?
            'Saving New User'
            :
            'New User Created'
          }
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {savingUser ?
          <center id="not-found">
            <img alt="loader" src={require("../../../static/images/spinner.gif")} />
            <h5>Saving User...</h5>
          </center>
          :
          <Fragment>
            <p>
              Your user has been successfully created.
            </p>
            <br/>
            <p>
              Username: <strong>{newUser.username}</strong>
            </p>
            <br/>
            <p>
              Temporary Password: <strong>{newUser.password} </strong>
            </p>
            <br/>

            <p>
              <strong>Please copy this username and temporary password combination.</strong> If they are lost, you will have to contact the database administrator to regain access to this user's account.
            </p>
          </Fragment>
        }
      </Modal.Body>

      <Modal.Footer>
        {savingUser ?
          null
          :
          <Button onClick={handleClose}>
            OK
          </Button>
        }
      </Modal.Footer>
    </Modal>
  )
}

export default NewUserCreatedModal



// WEBPACK FOOTER //
// ./src/routes/manager/components/NewUserCreatedModal.js